import { Record } from 'immutable';

import Organization from 'entities/organization/model';
import { VolunteerReward } from 'generated/graphql';

interface Milestone {
  name: string;
}

interface Deed {
  id: string;
  name: string;
  type: string;
}

interface User {
  id: string;
  mainPicture: string;
  fullName: {
    first: string;
    last: string;
  };
}

const properties = {
  id: '',
  deed: {
    id: '',
    name: '',
    type: '',
  },
  user: {
    id: '',
    name: '',
  },
  nonprofit: {
    id: '',
    name: '',
  },
  company: {
    id: '',
    name: '',
  },
  duration: 0,
  date: '',
  createdAt: '',
  milestone: {},
  notes: '',
  approval: '',
  externalNonprofitId: '',
  externalNonprofitName: '',
  volunteerReward: '',
  roleId: '',
};

export default class VolunteerTime extends Record(properties, 'VolunteerTime') {
  public readonly id!: string;

  public readonly deed!: Deed;

  public readonly user!: User;

  public readonly nonprofit!: Organization;

  public readonly company!: Organization;

  public readonly duration!: number;

  public readonly date!: Date;

  public readonly createdAt!: Date;

  public readonly milestone!: Milestone;

  public readonly notes!: string;

  public readonly externalNonprofitId!: string;

  public readonly externalNonprofitName!: string;

  public readonly volunteerReward!: string | undefined;

  public readonly roleId!: string | undefined;

  public readonly VolunteerReward!: VolunteerReward | undefined;

  public readonly approval!: 'Approved' | 'Pending' | 'Rejected';

  constructor(values: any = {}) {
    super({
      ...values,
      id: values._id || values.id,
      deed: values.Deed
        ? {
            ...values.Deed,
            id: values.Deed._id || values.Deed.id,
          }
        : values.deed
        ? {
            ...values.deed,
            id: values.deed._id || values.deed.id,
          }
        : undefined,
      user: values.User
        ? {
            ...values.User,
            id: values.User._id || values.User.id,
          }
        : values.user
        ? {
            ...values.user,
            id: values.user._id || values.user.id,
          }
        : undefined,
      nonprofit: values.Nonprofit
        ? {
            ...values.Nonprofit,
            id: values.Nonprofit._id || values.Nonprofit.id,
          }
        : values.nonprofit
        ? {
            ...values.nonprofit,
            id: values.nonprofit._id || values.nonprofit.id,
          }
        : undefined,
      company: values.Company
        ? {
            ...values.Company,
            id: values.Company._id || values.Company.id,
          }
        : values.company
        ? {
            ...values.company,
            id: values.company._id || values.company.id,
          }
        : undefined,
      roleId: values.roleId ? values.roleId : undefined,
      date: values.date ? new Date(values.date) : undefined,
      createdAt: values.createdAt ? new Date(values.createdAt) : undefined,
    });
  }
}
